/*
 * Web blanca · portada, colección y lavandería. Sin dependencias.
 * - Pastillas de «¿Qué le pasa a tu par?» (tabs accesibles).
 * - Comparador antes/después (input range → --pos).
 * - Botón «Pregúntale a Jack» (window.jackAbrir de jack-fab; si no, WhatsApp).
 * - Barra fija del carrito (celular): mismo cálculo que shipping-progress.
 * - Carriles que avanzan solos en celular ([data-bh-auto], kits y reseñas).
 * - Colección en computador: cada filtro aplica solo (como la colección actual).
 * Agregar al carrito lo atiende cart-controller.js ([data-quick-add]).
 */
(function () {
  if (window.__bhHome) return;
  window.__bhHome = true;

  function initTabs(root) {
    if (root.dataset.bhReady) return;
    root.dataset.bhReady = "1";
    var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-bh-tab]"));
    function activate(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute("aria-controls"));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener("click", function () { activate(tab, false); });
      tab.addEventListener("keydown", function (e) {
        var k = e.key, n = null;
        if (k === "ArrowRight" || k === "ArrowDown") n = tabs[(i + 1) % tabs.length];
        if (k === "ArrowLeft" || k === "ArrowUp") n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (k === "Home") n = tabs[0];
        if (k === "End") n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); activate(n, true); }
      });
    });
  }

  function initBa(fig) {
    if (fig.dataset.bhReady) return;
    fig.dataset.bhReady = "1";
    var range = fig.querySelector("[data-bh-ba-range]");
    if (!range) return;
    var set = function () { fig.style.setProperty("--pos", range.value + "%"); };
    range.addEventListener("input", set);
    set();
  }

  // ---------- Barra fija del carrito ----------
  var sticky = null;
  var justAdded = "";
  function clp(cents) {
    return "$" + Math.round(cents / 100).toLocaleString("es-CL");
  }
  function paintSticky(cart) {
    if (!sticky || !cart || !Array.isArray(cart.items)) return;
    if (!justAdded && window.__bhAddedId) {
      var hit = cart.items.find(function (it) { return String(it.variant_id) === String(window.__bhAddedId); });
      if (hit) justAdded = hit.product_title.split(" - ")[0].split(" — ")[0];
    }
    var thr = parseInt(sticky.dataset.threshold, 10) || 0;
    var eligible = 0, count = 0;
    cart.items.forEach(function (it) {
      var props = it.properties || {};
      // Regalos que agrega el carrito (Sponge, preventa): no cuentan como productos.
      var gift = Object.keys(props).some(function (k) { return k.indexOf("_regalo") === 0 && props[k] === "1"; });
      if (!gift) count += it.quantity;
      if (it.requires_shipping && props._regalo_cyber !== "1") eligible += it.final_line_price;
    });
    var withCode = (cart.cart_level_discount_applications || []).some(function (d) { return d.type === "discount_code"; });
    var added = sticky.querySelector("[data-bh-sticky-added]");
    var left = sticky.querySelector("[data-bh-sticky-left]");
    var fill = sticky.querySelector("[data-bh-sticky-fill]");
    if (count === 0) { sticky.hidden = true; return; }
    added.textContent = justAdded ? "✓ Agregaste " + justAdded : "🛒 " + count + (count === 1 ? " producto" : " productos") + " en tu carrito";
    if (!thr || withCode) {
      left.textContent = "";
      fill.style.width = "100%";
    } else if (eligible >= thr) {
      left.textContent = "🚚 Envío gratis";
      fill.style.width = "100%";
    } else {
      left.textContent = "faltan " + clp(thr - eligible) + " para envío gratis";
      fill.style.width = Math.max(4, Math.round((eligible * 100) / thr)) + "%";
    }
    updateStickyVisibility();
  }
  function updateStickyVisibility() {
    if (!sticky) return;
    var c = window.SneakCleanCartController;
    var open = c && typeof c.isOpen === "function" ? c.isOpen() : false;
    var hasItems = sticky.querySelector("[data-bh-sticky-added]").textContent !== "";
    sticky.hidden = open || !hasItems;
  }
  var fetchTimer = null;
  function refreshCart(delay) {
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () {
      fetch((window.SC_CONFIG && window.SC_CONFIG.rootUrl ? window.SC_CONFIG.rootUrl : "/") + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          paintSticky(cart);
        })
        .catch(function () {});
    }, delay || 0);
  }
  function initSticky() {
    var found = document.querySelector("[data-bh-sticky]");
    if (!found) return;
    // La sección puede quedar dentro de un ancestro con transform (sc-reveal),
    // que rompe position:fixed. Se cuelga directo del body.
    if (found.parentNode !== document.body) {
      document.querySelectorAll("body > [data-bh-sticky]").forEach(function (old) { if (old !== found) old.remove(); });
      document.body.appendChild(found);
    }
    if (sticky === found) return;
    sticky = found;
    if (parseInt(sticky.dataset.cart, 10) > 0) refreshCart(0);
    new MutationObserver(updateStickyVisibility).observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
  }
  document.addEventListener("sneakclean:cart-updated", function (e) {
    if (e.detail && e.detail.cart) paintSticky(e.detail.cart);
  });
  // Fase de captura: cart-controller.js puede cortar la propagación del clic.
  document.addEventListener("click", function (e) {
    var add = e.target.closest && e.target.closest("[data-quick-add]");
    if (add) {
      window.__bhAddedId = add.getAttribute("data-variant-id");
      justAdded = "";
      refreshCart(1800);
    }
  }, true);
  document.addEventListener("click", function (e) {
    var jack = e.target.closest && e.target.closest("[data-bh-jack]");
    if (jack && typeof window.jackAbrir === "function") {
      e.preventDefault();
      var texto = jack.getAttribute("data-bh-jack-texto");
      window.jackAbrir(texto ? { texto: texto } : {});
    }
  });

  // ---------- Colección: en computador cada filtro aplica solo ----------
  if (!window.__cw2CatalogAutoApply) {
    window.__cw2CatalogAutoApply = true;
    document.addEventListener("change", function (event) {
      var input = event.target.closest && event.target.closest("[data-filter-drawer] input");
      if (!input) return;
      if (window.matchMedia("(max-width: 900px)").matches) return;
      var form = input.closest("[data-catalog-form]");
      if (form && typeof form.requestSubmit === "function") form.requestSubmit();
    });
  }

  // ---------- Productos en acción: el video corre solo mientras se ve ----------
  function initVideos(rail) {
    if (rail.dataset.bhListo) return;
    rail.dataset.bhListo = "1";
    var vids = rail.querySelectorAll("[data-bh-video]");
    var quieto = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if ("IntersectionObserver" in window && !quieto) {
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting && en.intersectionRatio >= 0.6) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: [0, 0.6] });
      vids.forEach(function (v) { io.observe(v); });
    }
    rail.addEventListener("click", function (e) {
      var card = e.target.closest(".bh-video__media");
      if (!card) return;
      var v = card.querySelector("[data-bh-video]");
      var b = card.querySelector("[data-bh-sonido]");
      if (!v) return;
      var activar = v.muted;
      vids.forEach(function (o) { o.muted = true; });
      rail.querySelectorAll("[data-bh-sonido]").forEach(function (x) { x.textContent = "🔇"; x.setAttribute("aria-label", "Activar sonido"); });
      v.muted = !activar;
      if (activar) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        if (b) { b.textContent = "🔊"; b.setAttribute("aria-label", "Silenciar"); }
      }
    });
  }

  // ---------- Carriles que avanzan solos (celular) ----------
  // [data-bh-auto="ms"]: una tarjeta cada ms mientras el carril se ve. Se
  // detiene 8 s cada vez que la persona lo toca, lo desliza o pasa el mouse,
  // y al final vuelve al inicio. En computador el carril es grilla (no hay
  // desborde) y no hace nada; con «reducir movimiento», tampoco.
  function initAuto(rail) {
    if (rail.dataset.bhAutoListo) return;
    rail.dataset.bhAutoListo = "1";
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var ms = Math.max(2500, parseInt(rail.getAttribute("data-bh-auto"), 10) || 3500);
    var visible = !("IntersectionObserver" in window);
    var quietoHasta = 0;
    function pausa() { quietoHasta = Date.now() + 8000; }
    ["pointerdown", "touchstart", "wheel", "mouseenter", "mousemove", "focusin"].forEach(function (ev) {
      rail.addEventListener(ev, pausa, { passive: true });
    });
    if (!visible) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.5 }).observe(rail);
    }
    setInterval(function () {
      if (!visible || document.hidden || Date.now() < quietoHasta) return;
      var max = rail.scrollWidth - rail.clientWidth;
      if (max < 8) return;
      var item = rail.firstElementChild;
      if (!item) return;
      var paso = item.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0);
      var ir = rail.scrollLeft >= max - 4 ? 0 : Math.min(rail.scrollLeft + paso, max);
      rail.scrollTo({ left: ir, behavior: "smooth" });
    }, ms);
  }

  function init() {
    document.querySelectorAll("[data-bh-tabs]").forEach(initTabs);
    document.querySelectorAll("[data-bh-ba]").forEach(initBa);
    initSticky();
    document.querySelectorAll("[data-bh-videos]").forEach(initVideos);
    document.querySelectorAll("[data-bh-auto]").forEach(initAuto);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
